module.exports = __webpack_public_path__ + "Daniel_heart.jpg?12c8bbd0f137b56f3f6634bb31e1da13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/Daniel_heart.jpg
// module id = 74
// module chunks = 0